import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Chevron icons from react-icons

export default function Expandable({ question, answer }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div onClick={toggleExpand} className="flex-spaceBtwn cursorPointer">
        <span className="mr-32">{question}</span>
        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {isExpanded && (
        <div className="mt-16">
          <p>{answer}</p>
        </div>
      )}

      <hr className="mt-24" />
    </div>
  );
}
